import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';
import { createClassNames } from "../../../../../infrastructure/helpers";
import Icon from "../../../../icons/Icon";

class CanvasComponentsBarToggler extends React.Component {

  static defaultProps = {
    isActive: true,
    onPress: () => {}
  };

  static propTypes = {
    containerStyle: PropTypes.object,
    containerClass: PropTypes.string,
    disabled: PropTypes.bool,
    isActive: PropTypes.bool,
    onPress: PropTypes.func
  };

  render() {
    const btnStyles = [styles.btnCommonTouchable, this.props.containerClass];
    const { onPress, isActive } = this.props;

    if (isActive) {
      btnStyles.push(styles.btnActiveTouchable);
    }

    const btnClass = createClassNames(btnStyles);

    return (
      <button type="button"
              className={btnClass}
              style={this.props.containerStyle}
              disabled={this.props.disabled}
              onClick={onPress}>
        { isActive && (<Icon name="ModalClose" width="14px" height="14px"/>) }
        { !isActive && (<Icon name="Smile" width="27px" height="27px" style={{ width: '27px', height: '27px' }}/>) }
      </button>
    );
  }
}

export default CanvasComponentsBarToggler;